module.exports = __webpack_public_path__ + "static/media/productive-icon.b6278b6d.png";